import { Solicitacao } from '@/types/solicitacao';
import type { ProblemaFormData } from '@/types/problema';
import type { ProblemaOrigem } from '@/hooks/useProblemas';

/**
 * Mapeia urgencia/impacto/prioridade da Solicitação (incidente/requisicao)
 * para os enums aceitos pelo Problema.
 */
const mapImpacto = (i?: string): ProblemaFormData['impacto'] => {
  if (i === 'critico') return 'alto';
  if (i === 'baixo' || i === 'medio' || i === 'alto') return i as any;
  return 'medio';
};

const mapUrgencia = (u?: string): ProblemaFormData['urgencia'] => {
  if (u === 'baixa' || u === 'media' || u === 'alta' || u === 'critica') return u as any;
  return 'media';
};

const mapPrioridade = (p?: string): ProblemaFormData['prioridade'] => {
  if (p === 'baixa' || p === 'media' || p === 'alta' || p === 'critica') return p as any;
  return 'media';
};

export function buildProblemaFromOrigem(origem: Solicitacao, tipoOrigem: 'incidente' | 'requisicao'): {
  initialData: Partial<ProblemaFormData>;
  origem: ProblemaOrigem;
} {
  const prefixo = tipoOrigem === 'incidente' ? 'Incidente' : 'Requisição';
  const titulo = `[Originado de ${origem.numero}] ${origem.titulo}`.slice(0, 240);
  const descricaoBase = origem.descricao ? `${origem.descricao}\n\n---\n` : '';
  const descricao = `${descricaoBase}Origem: ${prefixo} ${origem.numero}`;

  return {
    initialData: {
      titulo,
      descricao,
      categoria_id: undefined, // categoria de problema é distinta
      urgencia: mapUrgencia(origem.urgencia),
      impacto: mapImpacto(origem.impacto),
      prioridade: mapPrioridade(origem.prioridade),
      client_id: origem.client_id,
      grupo_responsavel_id: origem.grupo_responsavel_id,
      status: 'aberto',
    },
    origem: {
      tipo: tipoOrigem,
      id: origem.id,
      numero: origem.numero,
    },
  };
}
